var _path, _rect, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyMediaLibrary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 68,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.613 21.54c-.737 0-1.455.079-2.154.21a10.87 10.87 0 00.314-2.553c0-6.184-5.179-11.197-11.567-11.197-6.008 0-10.943 4.435-11.51 10.108-6.028.995-10.572 5.417-10.572 10.724 0 .032.006.063.006.095 0 0-.292 1.78 0 4.073h44.638c1.491 0 2.597-1.412 2.189-2.832-1.429-4.983-5.962-8.627-11.344-8.627zM69.86 26.207c-1.714-5.891-7.153-10.199-13.611-10.199-.884 0-1.746.093-2.584.247a12.74 12.74 0 00.376-3.018C54.04 5.927 47.827 0 40.16 0c-7.207 0-13.13 5.243-13.81 11.95-7.232 1.177-12.684 6.404-12.684 12.678 0 .038.007.075.007.112h3.612c2.87 0 5.242 2.105 5.592 4.816h44.356c1.789 0 3.116-1.67 2.627-3.349zm-52.82 1.941H4.663A3.667 3.667 0 001 31.812v2.524A3.667 3.667 0 004.663 38H17.04a3.668 3.668 0 003.664-3.664v-2.524a3.668 3.668 0 00-3.664-3.664z",
    fill: "#EAECEF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 22,
    width: 59,
    height: 41,
    rx: 6,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 29a2 2 0 012-2h45a2 2 0 012 2v27a2 2 0 01-2 2H42a2 2 0 01-2-2V29z",
    fill: "#EEF0F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.453 24C38.627 24 37 25.626 37 27.535v29.93C37 59.375 38.627 61 40.453 61h48.094C90.373 61 92 59.374 92 57.465v-29.93C92 25.625 90.373 24 88.547 24H40.453zM35 27.535C35 24.554 37.49 22 40.453 22h48.094C91.51 22 94 24.554 94 27.535v29.93C94 60.446 91.51 63 88.547 63H40.453C37.49 63 35 60.446 35 57.465v-29.93z",
    fill: "#B8C1CA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.189 35.402c0 2.282-1.823 4.134-4.072 4.134-2.248 0-4.071-1.852-4.071-4.134 0-2.283 1.823-4.134 4.071-4.134 2.249 0 4.072 1.851 4.072 4.134zm3.264 12.244l10.18 10.334H87a2 2 0 002-2V51.5L74.721 36.278c-1.282-1.315-3.013-1.315-4.071 0L59.453 47.646zM40 56a2 2 0 002 2h24.468L53.127 44.597a2 2 0 00-2.835 0L40 54.937V56z",
    fill: "#B8C1CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyMediaLibrary);
export default __webpack_public_path__ + "static/media/emptyMediaLibrary.626379023fd6076b18260b5f71e81480.svg";
export { ForwardRef as ReactComponent };